import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#FFF"
        d="M7 12L3 8l1.333-1.334L7 9.334 12.333 4l1.334 1.333L7 12z"
      ></path>
    </svg>
  )
}

export default Icon
